module.exports = __webpack_public_path__ + "img/wait.4c07651c.png";